import React, { useState } from 'react';
import { Container, AppBar, Toolbar, Typography, Box, Grid, Paper } from '@mui/material';
import AdminRestaurantsList from './AdminRestaurantsList';
import AdminAddRestaurant from "./AdminAddRestaurant";

const AdminDashboard = ({ token, onLogout }) => {
    const [activeView, setActiveView] = useState(null); // null, 'restaurants' lub 'addRestaurant'

    const handleShowRestaurants = () => {
        setActiveView('restaurants');
    };

    const handleShowAddRestaurant = () => {
        setActiveView('addRestaurant');
    };

    const handleBackToDashboard = () => {
        setActiveView(null);
    };

    return (
        <Container>
            <AppBar position="fixed">
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography variant="h6">Panel Administratora</Typography>
                    <Typography variant="h6" onClick={onLogout} sx={{ cursor: 'pointer' }}>
                        Wyloguj się
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box mt={12}>
                {activeView === null && (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Paper
                                onClick={handleShowRestaurants}
                                sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }}
                                elevation={3}
                            >
                                <Typography variant="h6">Restauracje</Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                )}
                {activeView === 'restaurants' && (
                    <AdminRestaurantsList
                        token={token}
                        onBack={handleBackToDashboard}
                        onAddRestaurant={handleShowAddRestaurant}
                    />
                )}
                {activeView === 'addRestaurant' && (
                    <AdminAddRestaurant token={token} onBack={handleBackToDashboard} />
                )}
            </Box>
        </Container>
    );
};

export default AdminDashboard;